(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nmr-support-launcher"] && !Shopify.designMode) return;
  try {
    (() => {
  const root = document.querySelector('[data-nmr-support]');
  if (!root || root.dataset.nmrSupportBound === 'true') return;
  root.dataset.nmrSupportBound = 'true';

  const trigger = root.querySelector('[data-nmr-support-trigger]');
  const menu = root.querySelector('[data-nmr-support-menu]');
  const complaint = root.querySelector('[data-nmr-support-complaint]');
  const overlay = root.querySelector('[data-nmr-support-overlay]');
  const dialog = root.querySelector('[data-nmr-support-dialog]');
  const close = root.querySelector('[data-nmr-support-close]');
  const done = root.querySelector('[data-nmr-support-done]');
  const form = root.querySelector('#NmrSupportComplaintForm');
  const category = root.querySelector('[data-nmr-support-category]');
  const orderField = root.querySelector('[data-nmr-support-order-field]');
  const orderSelect = root.querySelector('[data-nmr-support-order]');
  const referenceInput = root.querySelector('[data-nmr-support-reference]');
  const success = root.querySelector('[data-nmr-support-success]');
  const successRef = root.querySelector('[data-nmr-support-success-ref]');
  const error = root.querySelector('[data-nmr-support-error]');
  let closeTimer = 0;
  let returnFocus = null;

  const setOpen = (open) => {
    root.dataset.open = open ? 'true' : 'false';
    trigger?.setAttribute('aria-expanded', open ? 'true' : 'false');
    menu?.setAttribute('aria-hidden', open ? 'false' : 'true');
  };

  const syncOrderRequirement = () => {
    if (!category || !orderField || !orderSelect) return;
    const needsOrder = category.value === 'Order';
    orderField.hidden = !needsOrder;
    orderSelect.required = needsOrder;
    if (!needsOrder) orderSelect.value = '';
  };

  const openModal = () => {
    setOpen(false);
    if (!overlay || !dialog) return;
    window.clearTimeout(closeTimer);
    returnFocus = document.activeElement;
    overlay.hidden = false;
    requestAnimationFrame(() => {
      overlay.dataset.visible = 'true';
      dialog.focus({ preventScroll: true });
    });
  };

  const closeModal = () => {
    if (!overlay || overlay.hidden) return;
    overlay.dataset.visible = 'false';
    window.clearTimeout(closeTimer);
    closeTimer = window.setTimeout(() => {
      overlay.hidden = true;
      if (returnFocus && typeof returnFocus.focus === 'function') {
        returnFocus.focus({ preventScroll: true });
      }
    }, 190);
  };

  const makeReference = () => {
    const now = new Date();
    const stamp = [
      String(now.getFullYear()).slice(-2),
      String(now.getMonth() + 1).padStart(2, '0'),
      String(now.getDate()).padStart(2, '0'),
      String(now.getHours()).padStart(2, '0'),
      String(now.getMinutes()).padStart(2, '0')
    ].join('');
    const random = Math.random().toString(36).slice(2, 7).toUpperCase();
    return 'NMR-' + stamp + '-' + random;
  };

  trigger?.addEventListener('click', () => setOpen(root.dataset.open !== 'true'));
  complaint?.addEventListener('click', openModal);
  close?.addEventListener('click', closeModal);
  done?.addEventListener('click', closeModal);
  category?.addEventListener('change', syncOrderRequirement);
  syncOrderRequirement();

  root.querySelector('[data-nmr-support-whatsapp]')?.addEventListener('click', () => setOpen(false));
  root.querySelector('[data-nmr-support-login]')?.addEventListener('click', () => setOpen(false));

  document.addEventListener('pointerdown', (event) => {
    if (root.dataset.open === 'true' && !root.contains(event.target)) setOpen(false);
  });

  overlay?.addEventListener('pointerdown', (event) => {
    if (event.target === overlay) closeModal();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    if (overlay && !overlay.hidden) {
      closeModal();
      return;
    }
    if (root.dataset.open === 'true') {
      setOpen(false);
      trigger?.focus({ preventScroll: true });
    }
  });

  form?.addEventListener('submit', (event) => {
    syncOrderRequirement();
    if (category?.value === 'Order' && orderSelect && !orderSelect.value) {
      event.preventDefault();
      orderSelect.reportValidity();
      return;
    }
    const reference = makeReference();
    if (referenceInput) referenceInput.value = reference;
    try {
      sessionStorage.setItem('nmrSupportLastReference', reference);
    } catch (e) {
      void e;
    }
  });

  if (success || error) openModal();

  if (success && successRef) {
    try {
      const reference = sessionStorage.getItem('nmrSupportLastReference');
      if (reference) successRef.textContent = reference;
    } catch (e) {
      void e;
    }
  }
})();
  } catch(e) { console.error(e); }
})();

})();
